class ProductCardPreview extends HTMLElement {
    constructor() {
        super();
        this.productVariantFieldset = this.querySelector('fieldset');
        if (this.productVariantFieldset) {
            this.productVariantFieldset.addEventListener('change', this.onVariantChange);
        }
    }

    disconnectedCallback() {
        if (this.productVariantFieldset) {
            this.productVariantFieldset.removeEventListener('change', this.onVariantChange);
        }
    }

    toFixed(number) {
        return Number(number / 100).toFixed(2) * 1
    }

    onVariantChange = () => {
        this.setVariantData();
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateVariantInput();
            this.renderProductInfo();
        }
        document.dispatchEvent(new CustomEvent("variantUpdate"));
    }

    updateOptions() {
        this.currentOption = Array.from(this.productVariantFieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    }

    updateMasterId() {
        this.currentVariant = this.variantData.find((variant) => {
            return !variant.options.map((option, index) => {
                return this.currentOption === option;
            }).includes(false);
        });
    }

    updateVariantInput() {
        const productForm = this.querySelector("product-preview-form");
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;

        const selectable = this.querySelector(".product-card__info__selectable input[type='checkbox']");
        selectable.value = this.currentVariant.id;

        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getSelectedVariant() {
        return this.variantData.find((variant) => variant.id === this.currentVariant.id)
    }

    getPriceFromSellingPlan(variant) {
        return variant.selling_plan_allocations.reduce((acc, plan) => {
            if (!acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            if (plan.price < acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            return acc;
        }, { price: null, compare_at_price: null })
    }

    getLowestPrice(variant) {
        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const planPrice = this.getPriceFromSellingPlan(variant);
            if (planPrice.price > 0) return planPrice;
        }

        return {
            compare_at_price: variant.compare_at_price,
            price: variant.price,
        };
    }

    isDifferenceVariantsPrice() {
        const variants = this.variantData
        if (variants && variants.length > 1) {
            const variantPrices = variants.map((variant) => variant.price)
            const uniqPrices = [...new Set(variantPrices)];
            return uniqPrices.length > 1;
        }

        return false;
    }

    removeErrorMessage() {
        const productForm = this.querySelector('product-preview-form');
        if (productForm) productForm.handleErrorMessage();
    }

    updatePrice(currentVariant, withFrom) {
        const updatedPrice = this.getLowestPrice(currentVariant);
        const priceContainer = this.querySelector(".product-preview-card__price");
        const checkboxPrice = this.querySelector(".product-card__info__selectable input[type='checkbox']:checked");

        if (updatedPrice.compare_at_price) {
            priceContainer.innerHTML = `
                ${withFrom ? "" : ""}
                <span> $${this.toFixed(updatedPrice.price).toLocaleString()}</span>
                <s>$${this.toFixed(updatedPrice.compare_at_price).toLocaleString()}</s>
            `
            // priceContainer.innerHTML = `
            //     ${withFrom ? '<span>From&nbsp;</span>' : ""}
            //     <span> $${this.toFixed(updatedPrice.price).toLocaleString()}</span>
            //     <s>$${this.toFixed(updatedPrice.compare_at_price).toLocaleString()}</s>
            // `
        } else if (checkboxPrice.dataset.discountedPrice) {
            priceContainer.innerHTML = `
                ${withFrom ? "" : ""}
                <span> $${this.toFixed(checkboxPrice.dataset.discountedPrice).toLocaleString()}</span>
                <s>$${this.toFixed(updatedPrice.price).toLocaleString()}</s>
            `
            // priceContainer.innerHTML = `
            //     ${withFrom ? '<span>From&nbsp;</span>' : ""}
            //     <span> $${this.toFixed(checkboxPrice.dataset.discountedPrice).toLocaleString()}</span>
            //     <s>$${this.toFixed(updatedPrice.price).toLocaleString()}</s>
            // `
        } else {
            priceContainer.innerHTML = `
                ${withFrom ? "" : ""}
                <span>$${this.toFixed(updatedPrice.price)}</span>
            `
            // priceContainer.innerHTML = `
            //     ${withFrom ? '<span>From&nbsp;</span>': ""}
            //     <span>$${this.toFixed(updatedPrice.price)}</span>
            // `
        }
    }

    getUpdatedImageSrcset(srcset, newSrc) {
        const regex = /(https:\/\/|\/\/)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(\?v=\d*)/gm
        return srcset.replace(regex, newSrc);
    }

    updateImageElement(imageSrc) {
        const imageObject = this.querySelector("media-gallery img");
        imageObject.src = `${imageSrc}`
        imageObject.srcset = this.getUpdatedImageSrcset(imageObject.srcset, imageSrc)
    }

    updateImages(currentVariant) {
        // thumbnail images
        // const variantImage = this.variantImages.find(({ id }) => id === currentVariant.id)
        // if (variantImage) {
        //     this.updateImageElement(variantImage.src);
        //     return
        // }
        const metafieldImage = this.variantImages.find((img) => img.id === currentVariant.id);
        if (metafieldImage) {
            this.updateImageElement(metafieldImage.src);
        }
        else if (currentVariant.featured_image) {
            this.updateImageElement(currentVariant.featured_image.src);
        }
    }

    renderProductInfo() {
        const currentVariant = this.getSelectedVariant();
        const isDifferentPrice = this.isDifferenceVariantsPrice();
        this.updatePrice(currentVariant, isDifferentPrice);
        this.updateImages(currentVariant);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(`#product-preview-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = this.querySelector(`#product-preview-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        // const price = document.getElementById(`price-${this.dataset.section}`);
        // if (!addButton) return;
        // if (price) price.classList.add('visibility-hidden');
    }

    parseVariantData() {
        const { variants, image_preview } = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return {
            variants,
            image_preview
        }
    }

    setVariantData() {
        this.variantData = this.variantData || this.parseVariantData().variants;
        this.variantImages = this.variantImages || this.parseVariantData().image_preview;
    }
}

customElements.define('product-card-preview', ProductCardPreview);